import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import style from './TextArea.module.css.js';

const TextArea = React__default.forwardRef(({ error, errorMessage, ...attrs }, ref) => {
    return (jsxs("div", { className: classNames(style.wrapper, attrs.className), children: [jsx("div", { className: classNames(style.inputWrapper, (error || errorMessage) && style.error), children: jsx("textarea", { ...attrs, ref: ref, className: classNames(style.textArea, (error || errorMessage) && style.error) }) }), errorMessage && jsx("span", { className: style.errorMessage, children: errorMessage })] }));
});
TextArea.displayName = "TextArea";

export { TextArea };
//# sourceMappingURL=TextArea.js.map
